import GLightbox from 'glightbox';


export default function () {

  document.head.insertAdjacentHTML('beforeend',
    '<link rel="stylesheet" type="text/css" href="/libs/glightbox.min.css">'
  );

  GLightbox({
    selector: '[data-glightbox]',
    touchNavigation: true,
    loop: true
  });

}
